import { forwardRef, type SVGProps } from 'react';

import { ArrowLeftToLineIcon } from '@air/design-icons';

/** Collapse a left-side panel (board, nav) — bar on the boundary, arrow points away from the panel. */
export const CollapsePanelLeftIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ className, ...props }, ref) => <ArrowLeftToLineIcon {...props} className={className} ref={ref} />,
);

CollapsePanelLeftIcon.displayName = 'CollapsePanelLeftIcon';
